import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BaseCoreState, baseSharedActions } from '../../_store';
import { HttpErrorStatus } from '../../shared/enums/http-error-status.enum';
import { BaseToastAlertClasses } from '../../shared/enums/base-toast-alert-classes.enum';
import { BASE_CUSTOM_ERROR_ALERTS } from '../constants/base-custom-error-alerts';
import { SYSTEM_ALERT_ERROR_TIME } from '../constants/base-time.const';

@Injectable({ providedIn: 'root' })
export class BaseHttpErrorService {
  constructor(public router: Router, private store: Store<BaseCoreState>) {}

  handle(errorResponse: HttpErrorResponse): void {
    if (errorResponse.status === HttpErrorStatus.Unauthorized) {
      this.router.navigateByUrl('401').then(() => {
        this.store.dispatch(
          baseSharedActions.addUniqueSystemAlert({
            payload: {
              class: BaseToastAlertClasses.error,
              body: errorResponse?.error?.message || 'Unauthorized',
              closeManually: false,
              id: errorResponse.status,
              unique: true,
            },
          })
        );
      });

      return;
    }

    if (errorResponse.status === HttpErrorStatus.Forbidden) {
      this.router.navigateByUrl('403').then(() => {
        this.store.dispatch(
          baseSharedActions.addUniqueSystemAlert({
            payload: {
              class: BaseToastAlertClasses.error,
              body: errorResponse?.error?.message || 'Forbidden',
              id: errorResponse.status,
              unique: true,
            },
          })
        );
      });

      return;
    }

    if (errorResponse.status === HttpErrorStatus.NotFound) {
      this.router.navigateByUrl('404').then(() => {
        this.store.dispatch(
          baseSharedActions.addUniqueSystemAlert({
            payload: {
              class: BaseToastAlertClasses.error,
              body: errorResponse.error?.message || 'Not found',
              id: errorResponse.status,
              duration: SYSTEM_ALERT_ERROR_TIME,
              unique: true,
            },
          })
        );
      });
      return;
    }

    if (
      errorResponse.status === HttpErrorStatus.BadRequest ||
      errorResponse.status === HttpErrorStatus.InternalServerError
    ) {
      let message = '';
      const errors = errorResponse?.error?.errors;
      if (Array.isArray(errors)) {
        for (const errMessage of errors) {
          message += errMessage + '\n';
        }
      } else if (errors) {
        for (const errMessage in errors) {
          message += errors[errMessage].join('\n') + '\n';
        }
      }
      this.store.dispatch(
        baseSharedActions.addUniqueSystemAlert({
          payload: {
            class: BaseToastAlertClasses.error,
            body: message || errorResponse?.error?.message || 'errorAlerts.default',
            id: errorResponse.status,
            unique: true,
          },
        })
      );
      return;
    }

    const customAlert = BASE_CUSTOM_ERROR_ALERTS.find((errorAlert) => errorAlert.status === errorResponse.status);
    if (customAlert) {
      this.store.dispatch(
        baseSharedActions.addUniqueSystemAlert({
          payload: {
            class: BaseToastAlertClasses.error,
            id: errorResponse.status,
            body: customAlert.message,
            unique: true,
          },
        })
      );
      return;
    }

    this.store.dispatch(
      baseSharedActions.addUniqueSystemAlert({
        payload: {
          class: BaseToastAlertClasses.error,
          body: errorResponse.error?.message || 'errorAlerts.default',
          id: errorResponse.status,
          duration: SYSTEM_ALERT_ERROR_TIME,
          unique: true,
        },
      })
    );
  }
}
